import MapLibreGL from "maplibre-gl";

enum DotNetMethod {
    HandleCloseAsync = "HandleCloseAsync"
}

type Entry = {
    popup: MapLibreGL.Popup;
    handleClose: () => void;
};

const registry = new Map<any, Entry>();

function initialize(
    dotNetHelper: any,
    map: MapLibreGL.Map,
    popupEl: HTMLElement,
    options: MapLibreGL.PopupOptions,
    lngLat: MapLibreGL.LngLat
): void {
    const popup = new MapLibreGL.Popup({
        offset: 16,
        closeButton: false,
        ...options
    })
        .setMaxWidth("none")
        .setLngLat(lngLat)
        .setDOMContent(popupEl)
        .addTo(map);

    const handleClose = () => {
        dotNetHelper.invokeMethodAsync(DotNetMethod.HandleCloseAsync)
    };

    popup.on("close", handleClose);

    registry.set(dotNetHelper, {
        popup,
        handleClose
    });
}

function close(dotNetHelper: any): void {
    const entry = registry.get(dotNetHelper);
    if (!entry) return;

    const { popup } = entry;

    popup.remove();
}

function destroy(dotNetHelper: any): void {
    const entry = registry.get(dotNetHelper);
    if (!entry) return;

    const { popup, handleClose } = entry;

    popup.off("close", handleClose);

    if (popup.isOpen()) {
        popup.remove();
    }

    dotNetHelper.dispose();

    registry.delete(dotNetHelper);
}

export default {
    initialize,
    close,
    destroy
}